// d:\pos_web\src\pages\stores\StoresPage.js
import React, { useMemo } from 'react';
import GenericListPage from '../GenericListPage';
import StoreForm from './StoreForm'; // We'll create this next

const storeColumns = [
  {
    header: 'Name',
    key: 'name',
    render: (store) => store.name,
  },
  {
    header: 'Code',
    key: 'code',
    render: (store) => <span className="font-mono text-indigo-600 font-semibold">{store.code}</span>,
  },
  {
    header: 'Location',
    key: 'location',
    render: (store) => store.location || 'N/A',
  },
  {
    header: 'Contact Person',
    key: 'contactPerson',
    render: (store) => store.contactPerson || 'N/A',
  },
  {
    header: 'Contact Phone',
    key: 'contactPhone',
    render: (store) => store.contactPhone || 'N/A',
  },
  {
    header: 'Status',
    key: 'isActive',
    render: (store) => (
      <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
        store.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
      }`}>
        {store.isActive ? 'Active' : 'Inactive'}
      </span>
    ),
  },
];

const StoresPage = () => {
  const storeFilterConfig = useMemo(() => [
    {
      name: 'name',
      type: 'text',
      label: 'Store Name',
    },
    {
      name: 'isActive',
      type: 'select',
      label: 'Status',
      options: [
        { value: '', label: 'All Statuses' },
        { value: 'true', label: 'Active' },
        { value: 'false', label: 'Inactive' },
      ],
    },
  ], []);

  return (
    <GenericListPage
      title="Stores"
      permission="manage_settings" // Example permission string
      entityEndpoint="stores" // API endpoint for stores
      columns={storeColumns}
      FormComponent={StoreForm}
      filterConfig={storeFilterConfig}
    />
  );
};

export default StoresPage;